




















helpers = require('../../helpers.coffee')

view_model =
  data: ->
    current_user: Session.current_user

  methods:
    redirect: ->
      if !@current_user.default_user
        return alertify.error(@$t('integrations.actions.email.setUp.error.defaultUserError'))
      Loader.on()
      window.location = @nylasOauthUrl()

    nylasOauthUrl: ->
      params = jQuery.param(
        client_id: process.env.NYLAS_CLIENT_ID
        response_type: 'code'
        scopes: process.env.NYLAS_SCOPES
        login_hint: @current_user.email
        redirect_uri: "#{window.location.protocol}//#{window.location.host}/configuracoes/integracoes"
        state: 'nylas'
      )
      "https://api.nylas.com/oauth/authorize?#{params}"

  created: ->
    @$router.push name: 'contatos/leads' unless @current_user.email_service_requires_authorization

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/index_nylas.vue